module.exports = "/images/vendor/pdfjs-dist/web/shadow.png?bf677598a57b9539055834af51cf6062";